import { createContext } from "react";

const MobileRechargeContext = createContext();

export default MobileRechargeContext;


